import React from "react";
import "./App.css";
import Weather from "./Weather";

function App() {
  return (
    <div className="App">
      <div className="container">
        <Weather defaultCity="Johannesburg" />
        <footer>
          This project was coded by <span> </span>
          <a
            href="https://github.com/Karabo-Khoza"
            target="_blank"
            rel="noreferrer"
          >
            Karabo Khoza
          </a>
          , is open-sourced on <span> </span>
          <a
            href="https://github.com/Karabo-Khoza/react-weather-app"
            target="_blank"
            rel="noreferrer"
          >
            Github
          </a>
          <span> </span>
          and hosted on <span> </span>
          <a
            href="https://reactweatherappprojec.netlify.app/"
            target="_blank"
            rel="noreferrer"
          >
            Netlify
          </a>
        </footer>
      </div>
    </div>
  );
}

export default App;
